export default {
  fetchDataFailed: "Failed to load user data, please try again or contact support",
  password_changed_other_tab: "Password updated in another tab",
  profile_updated_other_tab: "Profile updated in another tab",
  report_updated_other_tab: "The report configuration has been updated in another tab.",
  logged_out_other_tab: "You have been logged out in another tab",
  oauth: {
    processing: "Processing login request...",
  },
  ticket: {
    modal_title: "Submit Ticket",
    not_logged_in: "Please log in first",
    login_required:
      "Submitting a ticket requires logging into your account. Would you like to go to the login page?",
    go_to_login: "Go to Login",
    submit_success:
      "Ticket submitted successfully! Our support team will reply within 24-48 hours.",
    email: "Email",
    email_placeholder: "Please enter your email",
    type: "Issue Type",
    type_placeholder: "Please select issue type",
    subject: "Subject",
    subject_placeholder: "Please enter a subject for your ticket (5-100 characters)",
    description: "Issue Description",
    description_placeholder: "Please describe the issue in detail",
    submit_ticket: "Submit Ticket",
    submit_failed: "Failed to submit ticket!",
    email_send_failed_title: "Email Notification Issue",
    email_send_failed_desc:
      "Your ticket has been submitted successfully, but we encountered an issue sending email notifications. Our support team will still process your request.",
  },
};
